<template>
  <div class="order-detail-wrapper" v-if="dataDone">
    <div class="unpaid-status" v-if="orderData.status == 1">剩余支付时间为<van-count-down class="countdown" :time="orderData.leftTime" />，{{orderData.type == 3 ? '72小时' : '10分钟'}}内未支付，订单将自动取消</div>
    <div class="order-card">
      <div class="order-title">
        <div class="type">{{orderData.title}}</div>
        <div class="status unpay" v-if="orderData.status == 1"><icon icon-class="clock"></icon>待支付</div>
        <div class="status invalid" v-if="orderData.status == 2">已失效</div>
        <div class="status payed" v-if="orderData.status == 3">已支付</div>
        <div class="status payed" v-if="orderData.status == 4">已完成</div>
        <div class="status normal" v-if="orderData.status == -1">退款中</div>
        <div class="status normal" v-if="orderData.status == -2">已退款</div>
      </div>
      <div class="doc-info">
        <div class="avatar"><img :src="orderData.avatar"></div>
        <div class="doc-text">
          <div class="name">{{orderData.username}}医生<span>{{orderData.doc_title | jobTitleFilter}}</span></div>
          <div class="job">{{orderData.p_dep_title}} | {{orderData.dep_title}}</div>
        </div>
      </div>
    </div>
    <div class="order-detail">
      <div class="detail-title">订单信息</div>
      <section class="detail-section">
        <div class="detail-item">
          <div class="detail-type">订单编号</div>
          <div class="detail-content">{{orderData.number}}</div>
        </div>
        <div class="detail-item">
          <div class="detail-type">下单时间</div>
          <div class="detail-content">{{orderData.create_time | dateFilter}}</div>
        </div>
      </section>
      <div class="detail-title" v-if='orderData.type==4'>挂号信息</div>
      <section class="detail-section" v-if='orderData.type==4'>
        <div class="detail-item">
          <div class="detail-type">坐诊医生</div>
          <div class="detail-content">{{orderData.offline.docname}}</div>
        </div>
        <div class="detail-item">
          <div class="detail-type">坐诊地点</div>
          <div class="detail-content">{{orderData.offline.hospital}}-{{orderData.offline.position}}</div>
        </div>
        <!--
        <div class="detail-item">
          <div class="detail-type">候诊号</div>
          <div class="detail-content">{{orderData.offline.code}}</div>
        </div>
        
        -->
      </section>
      <section class="detail-section">
        <div class="detail-item">
          <div class="detail-type">支付方式</div>
          <div class="detail-content">微信支付</div>
        </div>
        <div class="detail-item">
          <div class="detail-type">订单金额</div>
          <div class="detail-content"><div class="payment">¥ {{orderData.money | int}}<span>{{orderData.money | float}}</span></div></div>
        </div>
      </section>
      <section class="detail-section" v-if="orderData.courier_company && orderData.courier_number">
        <div class="detail-item">
          <div class="detail-type">快递信息</div>
          <div class="detail-content express">{{orderData.courier_company}} {{orderData.courier_number}}</div>
        </div>
      </section>
    </div>
    <div class="invalid-tips" v-if="orderData.status == 2">您的订单超过{{orderData.type == 3 ? '72小时' : '10分钟'}}未支付已失效<br>如有疑问请<a :href="`tel:${serviceNumber}`">联系喜乐医生客服</a></div>
    <div class="pay-container" v-if="orderData.status == 1">
      <button class="cancel-order-button" v-if="orderData.type != 3" @click="cancelOrderShow = true">取消订单</button>
      <button class="pay-button" @click="pay" :disabled="paying">去支付</button>
    </div>
    <status-dialog v-if="invalidOrderShow" status-type="error" title="订单失效" sub-title="订单支付超时，感谢您的理解！" @close="invalidOrderShow = false"></status-dialog>
    <x-dialog v-if="cancelOrderShow" @close="cancelOrderShow = false">
      <div class="dialog-content">
        <div class="text">本次订单还未支付，是否取消</div>
        <div class="control">
          <button class="cancel" @click="cancelOrderShow = false">我再想想</button>
          <button class="confirm" @click="cancelOrderAction" :disabled="canceling">确定</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .order-detail-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    padding-top: 8px;
    .unpaid-status{
      width: 100%;
      padding: 8px 0;
      background: #F5A41E;
      color: #FFF;
      font-size: 12px;
      line-height: 14px;
      margin: -8px 0 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      .countdown{
        margin-left: 4px;
        color: #FFF;
        font-size: 12px;
      }
    }
    .order-card{
      background: #FFF;
      padding: 24px 20px 28px;
      margin-bottom: 8px;
      .order-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        .status{
          color: #666;
          &.unpay{
            color: @error;
            svg{
              color: @error;
              font-size: 16px;
              margin-right: 8px;
            }
          }
          &.payed{
            color: @xile;
          }
        }
      }
      .doc-info{
        margin-top: 28px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .avatar{
          width: 52px;
          height: 52px;
          overflow: hidden;
          border-radius: 50%;
          img{
            width: 100%;
          }
        }
        .doc-text{
          margin-left: 12px;
          font-size: 16px;
          line-height: 16px;
          color: @black;
          .name{
            font-weight: bold;
            span{
              margin-left: 8px;
              font-size: 14px;
              color: #999;
              font-weight: normal;
            }
          }
          .job{
            margin-top: 10px;
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
    .order-detail{
      padding: 24px 20px 28px;
      background: #FFF;
      .detail-title{
        font-size: 16px;
        line-height: 30px;
        color: @black;
        font-weight: bold;
        margin-top: 5px;

        height: 30px;
      }
      .detail-section{
        border-bottom: 1px solid #EEE;
        padding: 28px 0;
        &:last-child{
          border-bottom: 0;
        }
        .detail-item{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 28px;
          font-size: 14px;
          line-height: 14px;
          color: @black;
          &:last-child{
            margin-bottom: 0;
          }
          .detail-type{
            width: 88px;
            color: #666;
          }
          .detail-content{
            font-size: 14px;
            font-weight: bold;
            color: @black;
            .payment{
              font-size: 18px;
              font-weight: bold;
              color: @error;
              span{
                font-size: 12px;
              }
            }
            &.express{
              color: @xile;
              font-weight: bold;
            }
          }
        }
      }
    }
    .invalid-tips{
      margin-top: 21px;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
      color: #999;
      a{
        color: @xile;
        text-decoration: underline;
      }
    }
    .pay-container{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      background: #F7F7F7;
      .pay-button{
        @button-base();
        flex: 1;
        height: 40px;
        background: @error;
      }
      .cancel-order-button{
        @button-base();
        @button-border();
        width: 128px;
        height: 40px;
        background: transparent;
        margin-right: 15px;
        border-color: #999;
        color: #666;
        font-weight: normal;
      }
    }
  }
  .dialog-content{
    padding: 40px 0 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text{
      text-align: center;
      font-size: 16px;
      line-height: 22px;
      color: @black;
      font-weight: bold;
      .error-time{
        color: @error;
        font-size: 17px;
        line-height: 17px;
        font-weight: bold;
      }
      div{
        font-size: 15px;
        line-height: 15px;
        color: @black;
        margin-top: 8px;
        font-weight: normal;
      }
    }
    .control{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 40px;
      button{
        @button-base();
        width: 136px;
        height: 36px;
        &.cancel{
          @button-border();
          margin-right: 13px;
          border-color: #999;
          color: #666;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import statusDialog from '@/components/Common/statusDialog'
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        dataDone: false,
        orderData: {},
        // 防止按钮多次点击
        paying: false,
        // 订单过期弹窗
        invalidOrderShow: false,
        cancelOrderShow: false,
        canceling: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      serviceNumber() {
        return this.$store.state.servicePhone;
      }
    },
    components: {
      statusDialog,
      xDialog
    },
    created() {
      this.$root.post('/getOrderDetail', {
        order_id: this.$route.query.order_id
      }).then(data => {
        console.log(data)
        this.dataDone = true;
        data.money = data.money / 100;
        if(data.status == 1) {
          let now = new Date().getTime() / 1000;
          data.leftTime = (data.end_time - now) * 1000;
        }
        this.orderData = data;
      })

      // 获取微信sdk签名
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if(data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseWXPay']
          });
        }
      })
    },
    methods: {

      pay() {
        if(this.orderData.type == 3) {
          this.$router.push({name: 'PrescriptionDetail', params: {id: this.orderData.pret_id}})
        }else {
          this.paying = true;
          this.$root.post('/orderPay', {
            order_id: this.$route.query.order_id
          }).then(data => {
            console.log(data);
            let _this = this;
            if(data.status == 1) {
              // 调用微信支付接口
              wx.chooseWXPay({
                timestamp: data.info.timestamp,
                nonceStr: data.info.nonceStr,
                package: data.info.package,
                signType: data.info.signType,
                paySign: data.info.paySign,
                success(res) {
                  _this.paying = false;
                  if(res.errMsg == 'chooseWXPay:ok') {
                    // 如果是医事服务费订单支付完成后需要发送系统消息
                    if(_this.orderData.type == 1 || _this.orderData.type == 2) {
                      // 定义通用命令通知消息
                      let msg = new RongIMLib.CommandNotificationMessage({
                        name: 'OrderedChat',
                        data: {
                          type: _this.orderData.type,
                          startTime: _this.orderData.pre_start_time || null,
                          endTime: _this.orderData.pre_end_time || null,
                        }
                      });
                      let targetId = _this.orderData.doc_id.toString();
                      let conversationType = RongIMLib.ConversationType.PRIVATE;
                      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
                        onSuccess(message) {
                          console.log('消息发送成功', message);
                        },
                        onError(errorCode, message) {
                          console.log(errorCode);
                        }
                      })
                    }
                    if(_this.orderData.type==4){
                      _this.$router.push({path: '/patient/order/success', query: {order_number: _this.orderData.number,type: 4, order_id: _this.$route.query.order_id}})
                    }else{
                      _this.$router.push({path: '/patient/order/success', query: {order_number: _this.orderData.number,type: _this.orderData.type == 3 ? 2 : 1, order_id: _this.$route.query.order_id}})
                    }
                    
                  }else if(res.errMsg == 'chooseWXPay:cancel') {
                    _this.$notify('您已取消支付');
                  }else if(res.errMsg == 'chooseWXPay:fail') {
                    _this.$notify('支付出错，请稍后再试');
                  }
                },
                cancel(res) {
                  _this.paying = false;
                  _this.$notify('您已取消支付');
                },
                fail(res) {
                  _this.paying = false;
                  _this.$notify('支付出错，请稍后再试');
                },
              })
            }else if(data.status == 2) {
              _this.paying = false;
              _this.invalidOrderShow = true;
            }else {
              _this.paying = false;
              _this.$notify(data.msg);
            }
          })
        }

      },
      cancelOrderAction() {
        this.canceling = true;
        this.$root.post('/cancelOrder', {
          order_id: this.$route.query.order_id
        }).then(data => {
          console.log(data);
          this.canceling = false;
          if(data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '取消订单成功'
            })
            this.$router.go(-1);
          }else {
            this.$notify(data.msg);
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Order/detail.vue